export const measurementScopes = [
    "off" as const,
    "selected" as const,
    "visible" as const,
    "calibration" as const
]

export type MeasurementScope = typeof measurementScopes[number]

export interface APIAppMeasurerConfiguration {
    scope?: MeasurementScope
    completed_data_points_freq?: number
    reviewed_data_points_per?: number
    newly_ground_truth_per?: number
}

export function getDefaultMeasurementValue(
    value?: APIAppMeasurerConfiguration
): APIAppMeasurerConfiguration | undefined {
    if (value === undefined) {
        return undefined
    }
    const values = Object.values(value)
    if (
        values.filter(m => m === undefined || m === null).length ===
        values.length
    ) {
        return {
            scope: "off",
            completed_data_points_freq: 0,
            reviewed_data_points_per: 0,
            newly_ground_truth_per: 0
        }
    }
    return { ...value }
}
